export default "__VITE_ASSET__DPmacKMo__"